export default __webpack_public_path__ + "static/media/BC_441_BC_07210.6c032bc6.jpg";